import { render, staticRenderFns } from "./ColorPickerModal.vue?vue&type=template&id=3ff506f8&scoped=true&"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js&"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerModal.vue?vue&type=style&index=0&id=3ff506f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff506f8",
  null
  
)

export default component.exports